import request from '@/utils/request';

export function getWlRecycleDeviceList(data) {
  return request({
    url: '/wlRecycleDevice/queryPage',
    method: 'post',
    data,
  });
}
export function deleteWlRecycleDevice(id) {
  return request({
    url: `/wlRecycleDevice/delete/${id}`,
    method: 'get',
  });
}
export function addWlRecycleDevice(data) {
  return request({
    url: `/wlRecycleDevice/addDevice`,
    method: 'post',
    data
  });
}
export function editWlRecycleDevice(data) {
  return request({
    url: `/wlRecycleDevice/updateDevice`,
    method: 'post',
    data
  });
}
export function getWlRecycleDeviceListMap(data) {
  return request({
    url: `/wlRecycleDevice/list`,
    method: 'post',
    data
  });
}
export function getWlRecycleDeviceOrder(data) {
  return request({
    url: '/wlRecycleDevice/orderDevice',
    method: 'post',
    data,
  });
}

export function getWlRecycleDeviceOrderList(data) {
  return request({
    url: '/wlRecycleOrderDevice/queryPage',
    method: 'post',
    data,
  });
}
export function getWlRecycleDeviceOrderDetail(params) {
  return request({
    url: '/wlRecycleOrderDevice/orderDetail',
    method: 'get',
    params,
  });
}
export function getWlRecycleDeviceDetail(params) {
  return request({
    url: '/wlRecycleDevice/deviceDetail',
    method: 'get',
    params,
  });
}
export function upload() {
  return request({
    url: '/api/upload',
    method: 'get'
  });
}
export function getStreet() {
  return request({
    url: '/address/street/list',
    method: 'get'
  });
}
export function getCommunity(data) {
  return request({
    url: '/address/community/list',
    method: 'post',
    data
  });
}
export function getUserAmountList(data) {
  return request({
    url: '/wlUserAmount/queryPage',
    method: 'post',
    data
  });
}

export function getUserAmountListRecord(data) {
  return request({
    url: '/wlUserAmount/amountFlowQueryPage',
    method: 'post',
    data
  });
}